export default "__VITE_ASSET__CkOHtxK3__"